export const XY = 'XY';
export const ZX = 'ZX';
export const YZ = 'YZ';
export const UV = 'UV';
export const WU = 'WU';
export const VW = 'VW';
